export enum TriggerType  {
    PAGE_LOADED,
    FIELD_CHANGES,
    INPUT_CONTROL,
    INPUT_SELECTED,
    BUTTON_CLICKED,
    IMAGE_CLICKED,
    EDITOR_LOADS
}